module.exports = __webpack_public_path__ + "img/token.0b18759a.svg";